import React from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import Icons from '../../Icons';

// const AnswerResult = ({poll, answer}) => {
//     const value = Math.round(answer.ratingSum || 0);
//     const items = [];
//     for (let i = 0; i < answer.ratingMax; i++) {
//         items.push(i + 1);
//     }

//     return null

//     return (
//         <>
//             {items.map((i) => (
//                 <span key={i} className={'poll-rating-item' + (value > 0 && i === value ? ' active' : '')}>
//                     {i}
//                 </span>
//             ))}
//         </>
//     );
// };

export default ({ poll, headerHidden }) => {
    const { getProperty } = useLocaleContext();

    const renderResult = (answer) => {
        if (!answer.ratingSum || !answer.count) return null;

        const value = (answer.ratingSum / answer.count)?.toFixed(1);

        return <>
            <span className={'poll-answer-rating'}>
                {Array.from({ length: answer.ratingMax || 0 }).map((_, idx) => {
                    let fraction = value - idx;
                    fraction = fraction <= 0 ? 0 : fraction < 1 ? fraction.toFixed(1) : 1;
                    return <span
                        key={idx}
                        style={{ position: 'relative' }}
                        className={'poll-rating-item'}
                    >
                        <Icons name="rating_star" />
                        {!!fraction && <span style={{ position: 'absolute', top: 0, left: 0, overflow: 'hidden', width: `${fraction * 100}%` }} className={'poll-rating-item active'}>
                            <Icons name="rating_star" />
                        </span>}
                    </span>
                })}
            </span>
            <span className={'poll-answer-text'}>{value}</span>
        </>
    }

    return (
        <article className={'poll'}>
            {poll.imageUrl && (
                <div className="poll-image-container">
                    <img
                        src={poll.imageUrl}
                        className="poll-image"
                        alt={getProperty(poll, "text")}
                        title={getProperty(poll, "text")}
                    />
                </div>
            )}
            {!headerHidden && <p className={"poll-text"}>{getProperty(poll, 'text')}</p>}
            {poll.object && <p className={'poll-object'}>{poll.object}</p>}
            {poll.answer.map((answer) => (
                <p key={answer.id} className={'poll-answer poll-result-answer'}>
                    {!!getProperty(answer, 'text')?.trim() && <span className={'poll-answer-text'}>{getProperty(answer, 'text')}</span>}
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {renderResult(answer)}
                    </span>
                </p>
            ))}
        </article>
    );
};
